import { createTheme } from "@mui/material/styles";
import { Shadows } from "@mui/material/styles/shadows";
import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfigFile from "../../../tailwind.config";

// Tailwind Config objects are breaking the typescript expected types.
// @ts-expect-error
const tailwindTheme = resolveConfig(tailwindConfigFile).theme;

// This creates a MUI theme object, used by all MUI components at their core for
// color definitions. These colors
// may be accessed anywhere within the front end by name. All options for this
// object are available in the MUI documentation at:
// https://mui.com/material-ui/customization/theming/

const theme = createTheme({
  palette: {
    mode: "light",
    background: {
      default: tailwindTheme.colors["coolGrey"]["900"],
      paper: tailwindTheme.colors["coolGrey"]["1000"]
    },
    primary: {
      main: tailwindTheme.colors["durableTealDark"]["300"],
      contrastText: tailwindTheme.colors["durableTealDark"]["500"]
    },
    secondary: {
      main: tailwindTheme.colors["complementOrange"]["300"],
      contrastText: tailwindTheme.colors["coolGrey"]["1000"]
    }
  },
  shape: {
    borderRadius: 12 // rounded-xl
  },
  components: {
    MuiPaper: {
      styleOverrides: { root: { backgroundImage: "unset" } }
    },
    MuiFab: {
      styleOverrides: {
        root: {
          borderRadius: 12, // rounded-xl
          height: 56,
          boxShadow: `0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px
            rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%)`,
          textTransform: "none"
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 9999, // rounded-full
          textTransform: "none",
          margin: 1
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8 // rounded-lg
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(0, 0, 0, 0.09)",
          paddingLeft: "16px",
          paddingRight: "16px",
          paddingTop: "8px",
          paddingBottom: "8px",
          borderRadius: 4
        }
      }
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backdropFilter: "blur(10px) saturate(110%) brightness(100%);",
          transition: "backdrop-filter 1000ms"
        }
      }
    }
  },
  typography: {
    h1: {
      fontWeight: 700
    },
    fontFamily: "Ubuntu",
    fontSize: 15,
    fontWeightRegular: 400
  },
  shadows: Array(25).fill("none") as Shadows
});

export default theme;
